"use client";

import { useEffect, useRef } from "react";
import { getMode, getTheme } from "./client";
import { isMode } from "../default-theme";
import { useThemeSettings } from "./use-theme-settings";

type Saved = { theme: string; mode: string };

/** Keeps the colour theme and light/dark mode with the signed-in person's account, so they come back on another computer. Shown only where someone is signed in. On load it reads what the account has: if something is
 *  saved it is applied here; if nothing is, what this computer uses is saved. Afterwards every change made here is saved. A failed request changes nothing (the choice still holds on this computer). */
export function AppearanceSync() {
  const { theme, mode, setTheme, setMode } = useThemeSettings();
  const known = useRef<Saved | null>(null);
  useEffect(() => {
    fetch("/api/account/appearance", { cache: "no-store" }).then((r) => r.json()).then((saved: Saved & { signedIn: boolean }) => {
      if (!saved.signedIn) return;
      known.current = saved.theme && saved.mode ? { theme: saved.theme, mode: saved.mode } : { theme: "", mode: "" };
      if (known.current.theme && isMode(known.current.mode)) { setTheme(known.current.theme); setMode(known.current.mode); }
      else save({ theme: getTheme(), mode: getMode() }, known);
    }).catch(() => {});
  }, [setTheme, setMode]);
  useEffect(() => {
    if (known.current && known.current.theme && (known.current.theme !== theme || known.current.mode !== mode)) save({ theme, mode }, known);
  }, [theme, mode]);
  return null;
}

function save(next: Saved, known: { current: Saved | null }) {
  known.current = next;
  fetch("/api/account/appearance", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(next) }).catch(() => {});
}
